// extracted by mini-css-extract-plugin
export var orderDetails = "_so-2";
export var orderImage = "_so-1";
export var orderMeta = "_so-3";
export var orderSummary = "_so-0";
export var rightArrow = "_so-4";